import { AppointmentStatsCard } from './summary-cards/appointment-stats-card'
import {
  type AuthorizedSessionsBreakdown,
  AuthorizedSessionsCard,
} from './summary-cards/authorized-sessions-card'
import { LastUpcomingCard } from './summary-cards/last-upcoming-card'
import { TimeInCareCard } from './summary-cards/time-in-care-card'

export interface AppointmentSummary {
  completed_count: number
  missed_count: number
  last_appointment_date: string | null
  upcoming_appointment_date: string | null
  time_in_care: string | null
  care_happened: boolean
  care_ended: boolean
  session_limit?: AuthorizedSessionsBreakdown | null
  total_scheduled_count?: number
  future_scheduled_count?: number
}

interface Props {
  summary: AppointmentSummary
  scheduledCardVariant?: 'total-cell' | 'future-card'
}

export function AppointmentsSummaryCards({ summary, scheduledCardVariant = 'total-cell' }: Props) {
  return (
    <div className="mb-6 overflow-x-auto pb-3">
      <div className="flex min-w-fit items-stretch gap-6">
        <AppointmentStatsCard
          completedCount={summary.completed_count}
          missedCount={summary.missed_count}
          leadingCount={
            scheduledCardVariant === 'total-cell'
              ? summary.total_scheduled_count
              : summary.future_scheduled_count
          }
          leadingLabel={
            scheduledCardVariant === 'total-cell' ? 'Total Scheduled' : 'Scheduled Appts'
          }
        />
        <LastUpcomingCard
          lastAppointmentDate={summary.last_appointment_date}
          upcomingAppointmentDate={summary.upcoming_appointment_date}
        />
        <TimeInCareCard
          timeInCare={summary.time_in_care}
          careHappened={summary.care_happened}
          careEnded={summary.care_ended}
        />
        {summary.session_limit && <AuthorizedSessionsCard breakdown={summary.session_limit} />}
      </div>
    </div>
  )
}
